import { RouterProvider} from 'react-router-dom';
import { createTheme, ThemeProvider, responsiveFontSizes } from '@mui/material/styles';
import { router } from './routes/config';

let theme = createTheme({
  palette: {
    primary: {
      main: '#6D9A5B',
      dark: '#6D9A5B',
      
    },
  },
  typography: {
    fontFamily: 'Noto Sans, serif',
    h3: {
      fontFamily: 'Quicksand, sans-serif',
    },
    subtitle1: {
      fontSize: "18px",
    },
  },
  
});

theme = responsiveFontSizes(theme);

const App = () => (
  <div className="app">
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />
    </ThemeProvider>
  </div>
);

export default App;
